import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class ExtrasGraph extends ApplicationRecord {
  static jsonapiType = 'extras-graphs';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return ExtrasGraph.includes([]);
  }

  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() labels: [];
  @Attr() values: { [key: string]: [] };
}
